import { render } from "./menuItemSession.vue?vue&type=template&id=15f4db16&scoped=true"
import script from "./menuItemSession.vue?vue&type=script&lang=js"
export * from "./menuItemSession.vue?vue&type=script&lang=js"

import "./menuItemSession.vue?vue&type=style&index=0&id=15f4db16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f4db16"]])

export default __exports__